import { client } from 'utils/http';
import { getCookie } from 'utils/helperFunctions';
import {
  getGenerateSSOTokenUrl,
  getPublicDefaultSentimentKeywordsUrl,
  getPublicGenerateSentimentKeywordsUrl
} from './apiUrls';
import { SentimentKeywordsResponse, SSOTokenResponse } from './types';

const publicHeaders = (): Record<string, string> => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'X-Onboard-Token': getCookie('auth_token') || ''
});

const publicGet = <T>(url: string, params?: Record<string, unknown>): Promise<T> =>
  client({
    url,
    method: 'GET',
    params,
    headers: publicHeaders(),
    withCredentials: false
  }).then((response: any) => response?.data);

export function generateSSOToken(): Promise<SSOTokenResponse> {
  return publicGet<SSOTokenResponse>(getGenerateSSOTokenUrl());
}

export function getPublicDefaultSentimentKeywords(): Promise<SentimentKeywordsResponse> {
  return publicGet<SentimentKeywordsResponse>(getPublicDefaultSentimentKeywordsUrl());
}

export function generatePublicSentimentKeywords(text: string): Promise<SentimentKeywordsResponse> {
  return publicGet<SentimentKeywordsResponse>(getPublicGenerateSentimentKeywordsUrl(), { text });
}
